<template>
  <div class="vaccineMap">
    <div id="charts" style="width: 793px; height: 703px; margin-top: 10px"></div>
  </div>
</template>

<script>
import axios from 'axios';
import * as echarts from 'echarts';
import { areaCoordinateList, aliMapData } from '@/api/statistics';
export default {
  props: ['pointList', 'countrysideList', 'taskId'],
  data() {
    return {
      myChart: null,
      mapData: [],
      mapJson: {},
      level: JSON.parse(localStorage.getItem('userInfo_ZHXM')).provincialAndMunicipalLevel,
      cityStartArr: [
        {
          name: '榆林市',
          value: [109.73, 38.29]
        }
      ],
      cityEndArr: [
        {
          name: '榆阳区',
          value: [109.72, 38.28]
        },
        {
          name: '横山区',
          value: [109.292596, 37.964048]
        },
        {
          name: '府谷县',
          value: [111.069645, 39.029243]
        },
        {
          name: '靖边县',
          value: [108.80567, 37.596084]
        },
        {
          name: '定边县',
          value: [107.601284, 37.59523]
        },
        {
          name: '绥德县',
          value: [110.265377, 37.507701]
        }
      ],
      cityLinesCoordArr: [
        {
          coords: [
            [109.73, 38.29],
            [109.292596, 37.964048]
          ]
        },
        {
          coords: [
            [109.73, 38.29],
            [111.069645, 39.029243]
          ]
        },
        {
          coords: [
            [109.73, 38.29],
            [108.80567, 37.596084]
          ]
        },
        {
          coords: [
            [109.73, 38.29],
            [107.601284, 37.59523]
          ]
        },
        {
          coords: [
            [109.73, 38.29],
            [110.265377, 37.507701]
          ]
        }
      ],
      countyParams: {}, // 县级数据缓存
      userInfoZHXM: {}
    };
  },
  // mounted() {
  //   this.dealData()
  // },
  watch: {
    pointList(val) {
      if (val) {
        this.dealData();
      }
    },
    countrysideList(arr) {
      if (arr.length !== 0) {
        this.initCountryside(arr[0].name, arr[0].locations, arr[0].itemList); // 绘制路径地图
      } else if (arr.length === 0 && this.level === '2') {
        this.loadMap(this.countyParams.data.name, this.mapJson, this.countyParams.data.locations, this.countyParams.data.itemList);
      }
    }
  },
  methods: {
    dealData() {
      const userInfo_ZHXM = JSON.parse(localStorage.getItem('userInfo_ZHXM'));
      if (userInfo_ZHXM.mapAppAreasName) {
        this.userInfoZHXM = {
          areaCode: userInfo_ZHXM.nationalAreaCode,
          name: userInfo_ZHXM.mapAppAreasName ? userInfo_ZHXM.mapAppAreasName : userInfo_ZHXM.mapAppAreasName,
          areaLevel: userInfo_ZHXM.provincialAndMunicipalLevel
        };
      } else {
        this.$message({
          type: 'error',
          message: '请联系管理员配置区域地图'
        });
        return false;
      }

      this.cityStartArr = [];
      this.cityEndArr = [];
      this.cityLinesCoordArr = [];
      this.pointList.forEach(item => {
        this.cityStartArr.push({
          name: item.name,
          value: item.locations ? item.locations.split(',') : []
        });
        item.itemList.forEach(item2 => {
          this.cityEndArr.push({
            name: item2.name,
            value: item2.locations ? item2.locations.split(',') : []
          });
          this.cityLinesCoordArr.push({
            coords: [item.locations ? item.locations.split(',') : [], item2.locations ? item2.locations.split(',') : []]
          });
        });
      });
      // 省市区级别（1、省 2、市 3、区 4、镇 5、村）
      switch (this.level) {
        case '2':
          this.initMap(); // 加载市级
          break;
        case '3':
          this.initCountyMap(); // 加载县级
          break;
      }
    },
    // 初始化市级
    initMap() {
      this.myChart = echarts.init(document.getElementById('charts'));
      // axios.get(`https://geo.datav.aliyun.com/areas/bound/${610800}_full.json`).then((res) => {
      aliMapData({
        nationalCode: this.userInfoZHXM.areaCode,
        nationalLevel: this.userInfoZHXM.areaLevel
      }).then(res => {
        let areaList = [];
        res.data.data.features.forEach(item => {
          this.pointList.forEach(item2 => {
            // 市级循环
            item2.itemList.forEach(item3 => {
              // 县级循环
              if (item3.name.indexOf(item.properties.name) > -1) {
                // fei飞线对象与初始地图关联
                areaList.push({
                  deptId: item3.deptId,
                  name: item.properties.name,
                  adcode: item.properties.adcode,
                  area: item,
                  itemList: item3.itemList,
                  locations: item3.locations.split(',')
                });
              } else {
                // areaList.push({ name: item.properties.name, adcode: item.properties.adcode, area: item })
              }
            });
          });
        });
        this.mapJson = res.data.data;
        echarts.registerMap(this.userInfoZHXM.name, this.mapJson);
        // 生成市级地图option（由于市级地图需要飞线和下钻同时存在，所以数据需要经过特殊处理后才可实现）
        let option = this.createOption(this.userInfoZHXM.name, this.cityStartArr, this.cityEndArr, this.cityLinesCoordArr, areaList);
        this.myChart.setOption(option); // 绘制市级地图
        this.myChart.on('click', params => {
          if (params.data && params.data.deptId) {
            // 生成县级地图数据
            let mapJsonList = this.mapJson.features || [];
            for (let i in mapJsonList) {
              if (mapJsonList[i].properties.name == params.data.name) {
                this.mapJson.features = [].concat(mapJsonList[i]);
              }
            }
            this.mapData.push({
              name: this.cityName,
              value: Math.random() * 100,
              level: 'street'
            });
            // 渲染县级地图
            // this.loadMap(params.data.name, this.mapJson, params.data.locations, params.data.itemList)
            // this.countyParams = params
            // this.$emit('nextPart', params.data.adcode, params.data.deptId)
            areaCoordinateList({
              deptId: params.data.deptId,
              taskId: this.taskId
            }).then(res => {
              this.loadMap(params.data.name, this.mapJson, params.data.locations, res.data.data[0].itemList);
              params.data.itemList = res.data.data[0].itemList;
              this.countyParams = params;
              this.$emit('nextPart', params.data.adcode, params.data.deptId);
            });
          } else {
            console.log('下钻到底');
          }
        });
      });
    },
    // 初始化县级
    initCountyMap() {
      this.myChart = echarts.init(document.getElementById('charts'));
      aliMapData({
        nationalCode: this.userInfoZHXM.areaCode,
        nationalLevel: this.userInfoZHXM.areaLevel
      }).then(res => {
        this.mapJson = res.data.data;
        let features;
        if (this.pointList) {
          features = this.mapJson.features.find(item => {
            return this.pointList[0].name.indexOf(item.properties.name) > -1;
          });
        }

        this.mapJson.features = [].concat(features);
        this.loadMap(this.pointList[0].name, this.mapJson, this.pointList[0].locations.split(','), this.pointList[0].itemList);
      });
    },
    loadMap(mapName, data, locations, itemList) {
      if (Object.keys(data).length !== 0 && data) {
        // 注册地图
        echarts.registerMap(mapName, data);

        let startArr = [];
        let endArr = [];
        let lines_coord = [];
        startArr.push({ name: mapName, value: locations }); // 把县节点放进开始
        if (itemList) {
          // 如果有镇
          itemList.forEach(item => {
            endArr.push({ name: item.name, value: item.locations.split(',') }); // 镇放进结束
            lines_coord.push({ coords: [locations, item.locations.split(',')] });
            if (item.itemList) {
              // 如果有村
              startArr.push({ name: item.name, value: item.locations.split(',') }); // 镇节点放进开始
              item.itemList.forEach(town => {
                endArr.push({ name: town.name, value: town.locations.split(',') }); // 村放进结束
                lines_coord.push({ coords: [item.locations.split(','), town.locations.split(',')] });
              });
            }
          });
        }
        // 生成地图option
        let option = this.createOption(mapName, startArr, endArr, lines_coord);
        this.myChart.dispose();
        this.myChart = echarts.init(document.getElementById('charts'));
        this.myChart.setOption(option); // 绘制县级地图
        // this.myChart.on('click', () => {
        //   this.backMap()
        // })
      }
    },
    // 绘制人员路径
    initCountryside(name, locations, itemList) {
      this.loadMap(name, this.mapJson, locations.split(','), itemList);
    },
    createOption(mapName, startArr = [], endArr = [], lines_coord = [], areaList) {
      const option = {
        // backgroundColor: '#BFC',
        tooltip: {
          trigger: 'item',
          formatter: '{b}'
        },
        geo: {
          map: mapName,
          // zlevel: 10,
          // show:true,
          layoutCenter: ['50%', '50%'],
          roam: false,
          layoutSize: '100%',
          zoom: 1,
          label: {
            normal: {
              show: true,
              textStyle: {
                fontSize: 12,
                color: '#43D0D6'
              }
            },
            emphasis: {
              show: false,
              textStyle: {
                color: '#fff',
                fontSize: 12
              }
            }
          },
          itemStyle: {
            normal: {
              color: 'rgba(7, 21, 46, 0.5)',
              // color: 'rgba(128, 128, 128, 0)',
              borderWidth: 2,
              borderColor: '#1D5FD1',
              shadowColor: 'rgba(0, 249, 238, .6)',
              shadowOffsetY: 0,
              shadowBlur: 20
              // shadowOffsetX: 4,
              // shadowOffsetY: 0,
              // shadowBlur: 100,
            },
            emphasis: {
              color: '#062031' //移入后的颜色
            }
          },
          emphasis: {
            label: {
              color: '#FF0000',
              show: true
            }
          }
        },

        series: [
          {
            name: mapName,
            type: 'map',
            mapType: mapName,
            roam: false,
            selectedMode: false,
            showLegendSymbol: false,
            visibility: 'off',
            data: areaList || this.mapData,
            layoutCenter: ['50%', '50%'],
            layoutSize: '100%',
            label: {
              normal: {
                color: '#1D5FD1',
                show: true
              }
            },
            itemStyle: {
              normal: {
                areaColor: 'rgba(22,24,24, 0.5)',
                // border: 'none',
                borderColor: '#1D5FD1',
                borderWidth: 1,
                // opacity: 0.1,
                // borderColor: 'dodgerblue'
                borderType: 'solid'
              },
              emphasis: {
                show: true,
                areaColor: '#1D5FD1', //鼠标滑过区域颜色
                label: {
                  show: true,
                  textStyle: {
                    color: '#000'
                  }
                }
              }
            }
          },
          // 从哪来
          {
            type: 'effectScatter',
            coordinateSystem: 'geo',
            zlevel: 15,
            symbolSize: 8,
            rippleEffect: {
              period: 4,
              brushType: 'stroke',
              scale: 4
            },
            label: {
              normal: {
                show: false,
                color: '#1D5FD1',
                position: 'right', //显示位置1
                offset: [5, 10], //偏移设置
                formatter: function (params) {
                  //圆环显示文字
                  return params.data.name;
                },
                fontSize: 12
              }
            },
            itemStyle: {
              color: '#FFB800',
              opacity: 1
            },
            data: endArr // 终点集合
          },
          // 到哪去
          {
            type: 'effectScatter',
            coordinateSystem: 'geo',
            zlevel: 15,
            symbolSize: 12,
            rippleEffect: {
              period: 6,
              brushType: 'stroke',
              scale: 8
            },
            itemStyle: {
              color: '#1D5FD1',
              opacity: 1
            },
            data: startArr // 起点集合
          },
          // 路径
          {
            type: 'lines',
            coordinateSystem: 'geo',
            zlevel: 15,
            effect: {
              show: true,
              period: 5,
              trailLength: 0,
              symbol: 'arrow',
              color: '#01AAED',
              symbolSize: 8
            },
            lineStyle: {
              normal: { width: 1.2, opacity: 0.6, curveness: 0.2, color: '#FFB800' }
            },
            data: lines_coord // 路径数据集合 0起点 1终点
          }
        ]
      };
      return option;
    },
    backMap() {
      this.myChart.dispose(); // 销毁当前地图
      this.initMap(); // 加载市级地图
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/SmartLivestock/statistics/component/vaccineMapModule.vue